var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M21 19.875v.747a.365.365 0 0 1-.11.268.365.365 0 0 1-.268.11H3.378a.365.365 0 0 1-.268-.11.365.365 0 0 1-.11-.268v-.747c0-.51.125-.96.374-1.354a3.02 3.02 0 0 1 .966-.958c.396-.246.834-.47 1.314-.672.48-.202.961-.395 1.442-.58.48-.185.918-.38 1.314-.584.395-.206.717-.465.966-.778.25-.314.374-.673.374-1.077a4.95 4.95 0 0 1-.242-.268c-.102-.12-.282-.384-.54-.791a9.685 9.685 0 0 1-.686-1.292c-.199-.454-.38-1.046-.54-1.775A10.38 10.38 0 0 1 7.5 7.5c0-.61.119-1.19.356-1.745a4.534 4.534 0 0 1 .962-1.437 4.534 4.534 0 0 1 1.437-.962A4.383 4.383 0 0 1 12 3c.61 0 1.19.119 1.745.356a4.534 4.534 0 0 1 1.437.962c.404.405.725.884.962 1.437.237.554.356 1.136.356 1.745 0 .563-.041 1.112-.123 1.648a9.23 9.23 0 0 1-.32 1.42c-.133.41-.28.798-.44 1.164a7.136 7.136 0 0 1-.484.932c-.16.254-.307.476-.44.663a4.092 4.092 0 0 1-.32.413l-.123.132c0 .404.125.763.374 1.077.249.313.57.572.966.778.396.205.834.4 1.314.584.48.185.961.378 1.442.58.48.202.918.426 1.314.672.395.247.717.566.966.958.25.393.374.844.374 1.354z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.2f5de18fa79ad98384128660b27d7363.svg";
export { ForwardRef as ReactComponent };